<template>
    <html data-wf-page="5b17a0c3e17ccd5653bd4f4e" data-wf-site="5b1755d5269b9c5142d82ca3">
<head>
  <meta charset="utf-8">
  <title>Cabinet Manager | Colors</title>
  <meta content="Cabinet Manager | Dashboard" property="og:title">
  <meta content="width=device-width, initial-scale=1" name="viewport">
</head>
<body class="body-2">
  <MobileNav :project="project" :current-page="'items'"></MobileNav>
  <div class="wholewrapper">
    <div class="div-block-24">
      <NavSideBar :current-page="'colors'" :project="project"></NavSideBar>
      <div class="contentcontainer">
        <div class="contenttop">
          <div class="div-block-30">
            <div class="projectselector">
              <el-dropdown trigger="click" @command="switchProject" style="max-width:40vw">
                <span class="el-dropdown-link" style="color: #fff; font-weight: bold; word-wrap: break-word">{{ project.name }}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="project in projectList"
                    v-if="project.status !== 'closed'"
                    :key="project.id"
                    :command="project.id">{{ project.name }}
                  </el-dropdown-item>
                  <el-dropdown-item divided
                    :command="''">All Projects
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <SignInButton :user="user" @login="$emit('login')"></SignInButton>
          </div>
          <div class="div-block-32">
            <div class="text-block-16">Project Item</div>
          </div>
        </div>
        <div class="contentdown">
          <div class="downcontentdrawings">
            <el-input v-model="queryString" placeholder="Search by COLOR NAME" style="width: 100%;"></el-input>
            <div class="data">
              <div class="item-container" v-for="(color, index) in displayedColors" :key="index">
                <div class="item-head">
                  <div class="item-color">
                    <div class="tag-block" :style="`background-color: ${color.tag};`"></div>
                    <span class="item-name"> {{color.name}} </span>
                  </div>
                  <i class="material-icons" @click="editColor(color)">create</i>
                </div>
              </div>
            </div>
            <div class="page-selector">
              <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                :current-page.sync="pageNum"
                :page-size.sync="colorsPerPage"
                :page-sizes="[10, 20, 50, 100]"
                :total="passedColors.length">
              </el-pagination>
            </div>
          </div>
          <div class="powereddiv">
            <div class="div-block-14">
              <div class="text-block-9">Powered by </div>
              <a href="http://studioscreation.com" target="_blank" class="poweredlink w-inline-block">
                <div class="text-block-10">Studio S, Inc.</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <EditColorForm :color="editingColor" :project-id="currentProject" v-if="showEditColor" v-on:close-edit-color="showEditColor = false">
  </EditColorForm>
</body>
</html>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">WebFont.load({  google: {    families: ["Ubuntu:300,300italic,400,400italic,500,500italic,700,700italic","Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic","Dosis:regular,500,600,700,800"]  }});</script>

<!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
<script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
<script src="https://code.jquery.com/jquery-3.3.1.min.js" type="text/javascript" integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
<script src="../static/js/t2-cabinets-management-system.js" type="text/javascript"></script>
<!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->

<script>
import { db } from '../main'
import SignInButton from './SignInButton'
import NavSideBar from './NavSideBar'
import MobileNav from './MobileNav'
import EditColorForm from './EditColorForm'

export default {
  name: 'ProjectColor',
  props: ['user'],
  data () {
    return {
      dataReady: false,
      currentProject: "NO_PROJECT_SELECTED",
      projectList: [],
      project: {},
      remoteColors: [],
      pageNum: 1,
      colorsPerPage: 10,
      queryString: '',
      editingColor: {},
      showEditColor: false
    }
  },
  computed: {
    passedColors: function () {
      // the items can pass query filter
      if (!this.dataReady) {
        return []
      }

      let queryString = this.queryString ? this.queryString.toLowerCase() : ''     // In case of querySting is null or undefined
      // console.log('query =>', queryString)
      let remoteColors = this.remoteColors

      let passedColors = remoteColors.filter(color => {
        if (color.name.toLowerCase().indexOf(queryString) !== -1) {
          // console.log('MODEL MATCH')
          return true
        }
        return false
      })
      return passedColors
    },
    displayedColors: function () {
      // the items displayed on current page based on the page num
      let startIndex = (this.pageNum - 1) * this.colorsPerPage
      let endIndex = this.pageNum * this.colorsPerPage
      return this.passedColors.slice(startIndex, endIndex)
    }
  },
  firestore () {
    return {
      projectList: db.collection('project_list').where('version', '==', 2).orderBy('last_open_date','desc').limit(15)
    }
  },
  created: function () {
    this.currentProject = this.$route.query.project
    let initResult = this.initData()
  },
  watch: {
    $route: function () {
      this.currentProject = this.$route.query.project
    },
    currentProject: function () {
      // console.log('current project changed, link to new project')
      let initResult = this.initData()
      if (initResult) {
        // this.$notify({
        //   title: 'Success',
        //   message: 'Current project: ' + this.currentProject,
        //   type: 'success',
        //   duration: 3000,
        //   offset: 64
        // })
      }
    }
  },
  methods: {
    switchProject: function (projectId) {
      // console.log('switch to =>', projectId)
      if (projectId !== ''){
        this.$router.push({
          path: 'dashboard',
          query: {
            project: projectId
          }
        })
      } else {
        this.$router.push({
          path: '/'
        })
      }
    },
    initData: async function () {
      this.dataReady = false
      if (this.currentProject === 'NO_PROJECT_SELECTED') {
        return false
      }
      try {
        this.$bind('project', db.collection('project').doc(this.currentProject))
        // console.log('Bind Items for project => ', this.currentProject)
        this.$bind('remoteColors', db.collection('colors').where('projectId','==',this.currentProject))
        this.dataReady = true
        return true
      } catch (err) {
        console.warn(err)
        return false
      }
    },
    editColor: function (color) {
      this.editingColor = color
      this.showEditColor = true
    }
  },
  components: {
    SignInButton,
    NavSideBar,
    MobileNav,
    EditColorForm
  }
}

</script>

<style scoped>
.data :last-child {
  border-bottom: none;
}
.data {
  width: 100%;
}
.item-container {
  padding: 24px 4px;
  width: 100%;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}
.item-name {
  font-size: 14px;
  line-height: 21px;
  margin-right: 10vw;
  box-sizing: border-box;
}
.item-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.label {
  color: #aaaaaa;
}
.material-icons{
  color: #00838f;
  width: 18px;
  cursor: pointer;
}
.page-selector {
  text-align: center;
  margin-top: 36px;
}
.tag-block {
  display: inline-block;
  height: 12px;
  width: 12px;
  min-height: 12px;
  min-width: 12px;
  margin: 3px 12px 0 0;
}
.item-color {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  margin-top: 4px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectColor.vue